import { enqueueSnackbar, DownloadFile } from 'actions';

import {
	GenerateReportRequest
} from '../requests/ReportPPMRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GenerateReport = (siteId, reportType, activationDate, userId) => async (dispatch) => {
	await GenerateReportRequest(siteId, reportType, activationDate, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
